/**
 * Build / prerender sırasında beklenen gürültüyü susturmak için.
 * Next, searchParams kullanan API route'ları prerender ederken
 * NEXT_PRERENDER_INTERRUPTED fırlatır; Laravel build'de kapalıysa connection error olur.
 */

export function isNextProductionBuild(): boolean {
  const phase = process.env.NEXT_PHASE;
  return (
    phase === 'phase-production-build' ||
    (typeof phase === 'string' && phase.includes('build'))
  );
}

export function isPrerenderInterrupt(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const e = error as { digest?: string; message?: string; cause?: unknown };
  if (e.digest === 'NEXT_PRERENDER_INTERRUPTED' || e.digest === 'HANGING_PROMISE_REJECTION') {
    return true;
  }
  const msg = typeof e.message === 'string' ? e.message : '';
  if (
    msg.includes('bail out of prerendering') ||
    msg.includes('prerender is complete') ||
    msg.includes('HANGING_PROMISE_REJECTION')
  ) {
    return true;
  }
  if (e.cause) return isPrerenderInterrupt(e.cause);
  return false;
}

/** Build veya beklenen prerender bailout'ta loglama. */
export function shouldSilenceApiLog(...args: unknown[]): boolean {
  if (isNextProductionBuild()) return true;
  for (const arg of args) {
    if (isPrerenderInterrupt(arg)) return true;
    if (arg && typeof arg === 'object' && 'error' in arg) {
      if (isPrerenderInterrupt((arg as { error: unknown }).error)) return true;
    }
  }
  return false;
}

/** console.error drop-in: build / prerender bailout'ta no-op. */
export function logApiError(...args: unknown[]): void {
  if (shouldSilenceApiLog(...args)) return;
  console.error(...args);
}
